/**
 * 관심매장 목록 조회용 GraphQL 문서.
 * like 라우트 전용이므로 route 내부 api에 둠.
 * @see docs/file-structure.md
 */
import { gql } from "../../../__generated__";

export const GET_LIKED_STORES = gql(`
  query LikedStores($lat: Float, $lng: Float, $offset: Int, $limit: Int) {
    likedStores(lat: $lat, lng: $lng, offset: $offset, limit: $limit) {
      id
      lat
      lng
      title
      createdAt
      updatedAt
      isLiked
      distance
      products {
        id
        price
        discountPrice
        saleEndTime
        quantity
        createdAt
        updatedAt
      }
      todaysProducts {
        id
        name
        price
        img
        discountPrice
        userPrice
        saleEndTime
        quantity
        currentCount
        createdAt
        updatedAt
        menus {
          menu {
            name
            img
            price
          }
        }
      }
      img
      contactNumber
      closingHours
      reserveTime
      pack{
        id
        quantity
        price
        discountPrice
        userPrice
        quantity
        currentCount
        isOverTodayPickupTime
        isTodayEnabled
        isTomorrowEnabled
      }
      isProductAllSoldOut
      reviewCount
    }
  }
`);
